export default __webpack_public_path__ + "assets/images/6b75254ecf0c4b541e869166fd344c0d.webp";